import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { cn, FormCheckBox, FormSelect } from '@/core/ui';
import type { IStationSchema } from './schema';

const STARTING_AGENT_OPTIONS = [
  { label: 'Patient', key: 'patient' },
  { label: 'Examination', key: 'examination' },
  { label: 'Examiner', key: 'examiner' },
];

const _AgentConfigForm = ({ className }: { className?: string }) => {
  const form = useFormContext<IStationSchema>();

  return (
    <section className={cn('rounded-md border border-default-200 p-4', className)}>
      <p className='text-sm font-semibold mb-3'>Agent Config</p>
      <div className='flex flex-col gap-3'>
        <FormSelect
          id='entryAgent'
          name='aiConfig.agentConfig.entryAgent'
          control={form.control}
          label='Starting agent'
          placeholder='Select starting agent'
          variant='faded'
          className='rounded'
          options={STARTING_AGENT_OPTIONS}
        />
        <FormCheckBox control={form.control} name='aiConfig.agentConfig.multiAgent'>
          Multi-agent switch
        </FormCheckBox>
      </div>
    </section>
  );
};

export const AgentConfigForm = memo(_AgentConfigForm);
